module.exports = __webpack_public_path__ + "img/solidcolordance.35a98815.svg";